import { useContext } from "react";

import type { GtmSdk } from "..";
import { GtmContext } from "./context";

export const useGtmContext = (): { gtm: GtmSdk } => {
  const context = useContext(GtmContext);
  if (!context) {
    throw new Error("useGtmSdk must be used within a GtmSdkProvider");
  }
  return { gtm: context.sdk };
};
